export const getShapeProps = (shapeInfo) => {
  const { width, height } = shapeInfo;
  return (type) => {
    const shapeOptions = {
      rect: {
        width,
        height,
      },
      circle: {
        cx: Number(width) / 2,
        cy: Number(height) / 2,
        r: (Number(height) + Number(width)) / 4,
      },
    };

    return shapeOptions[type];
  };
};

export const getSvgProps = (shapeInfo) => {
  const { width, height } = shapeInfo;
  return (type) => {
    const svgProps = {
      rect: {
        width,
        height,
      },
      circle: {
        width,
        height,
      },
    };

    return svgProps[type];
  };
};
